"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNamespaceBuilder = exports.defaultNoMatchHandler = exports.createNamespaceStrategy = exports.validateCustomPropertyName = exports.ensureModuleImport = exports.parseModuleImportStatement = exports.processNamespace = exports.noCollisionNamespace = exports.StylableMeta = exports.Diagnostics = exports.Stylable = void 0;
var stylable_1 = require("./stylable");
Object.defineProperty(exports, "Stylable", { enumerable: true, get: function () { return stylable_1.Stylable; } });
var diagnostics_1 = require("./diagnostics");
Object.defineProperty(exports, "Diagnostics", { enumerable: true, get: function () { return diagnostics_1.Diagnostics; } });
var stylable_meta_1 = require("./stylable-meta");
Object.defineProperty(exports, "StylableMeta", { enumerable: true, get: function () { return stylable_meta_1.StylableMeta; } });
var resolve_namespace_factories_1 = require("./resolve-namespace-factories");
Object.defineProperty(exports, "noCollisionNamespace", { enumerable: true, get: function () { return resolve_namespace_factories_1.noCollisionNamespace; } });
var stylable_processor_1 = require("./stylable-processor");
Object.defineProperty(exports, "processNamespace", { enumerable: true, get: function () { return stylable_processor_1.processNamespace; } });
// low-level api
var import_1 = require("./helpers/import");
Object.defineProperty(exports, "parseModuleImportStatement", { enumerable: true, get: function () { return import_1.parseModuleImportStatement; } });
Object.defineProperty(exports, "ensureModuleImport", { enumerable: true, get: function () { return import_1.ensureModuleImport; } });
var css_custom_property_1 = require("./helpers/css-custom-property");
Object.defineProperty(exports, "validateCustomPropertyName", { enumerable: true, get: function () { return css_custom_property_1.validateCustomPropertyName; } });
// namespace helpers
var namespace_1 = require("./helpers/namespace");
Object.defineProperty(exports, "createNamespaceStrategy", { enumerable: true, get: function () { return namespace_1.createNamespaceStrategy; } });
Object.defineProperty(exports, "defaultNoMatchHandler", { enumerable: true, get: function () { return namespace_1.defaultNoMatchHandler; } });
Object.defineProperty(exports, "defaultNamespaceBuilder", { enumerable: true, get: function () { return namespace_1.defaultNamespaceBuilder; } });
// deprecations
__exportStar(require("./index-deprecated"), exports);
//# sourceMappingURL=index.js.map